import {
  Box,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  Text,
  useDisclosure,
  VStack,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { BsList } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { useAuth } from "../../store/auth/reducer";
import NavItem from "./NavItem";

export default function Sidebar() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const dispatch = useDispatch();
  const [ddOpen, setIsDDOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleDropdownToggle = () => {
    setIsDDOpen((prevState) => !prevState);
  };

  const handleClose = () => {
    onClose();
    setIsDDOpen(false);
  };
  const { busy, user } = useAuth();
  console.log(user, "jujujujujujujujujujujuju");

  const hasPermission = (resource: any, actions: any) => {
    const resourcePermissions = user?.permission?.find(
      (p: any) => p.resource === resource
    );
    return actions.every((action: any) =>
      resourcePermissions?.action.includes(action)
    );
  };

  return (
    <>
      <IconButton
        icon={<BsList />}
        //@ts-ignore
        ref={btnRef}
        onClick={onOpen}
        top={5}
        left={5}
        bg="transparent"
        // border="1px solid black"
        position="fixed"
        zIndex={300}
        // backgroundColor={"white"}
        _hover={{ color: "white", backgroundColor: "#000" }}
      ></IconButton>

      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={handleClose}
        //@ts-ignore
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          {/* <DrawerCloseButton
            _focus={{ border: "none" }}
            my={1.5}
            border="none"
            // color="white"
            _hover={{
              bg: "#cb30ff",
              color: "#fff",
            }}
          /> */}
          <DrawerHeader
            borderBottomWidth="1px"
            fontWeight="bold"
            textAlign="center"
            // background={"black"}
            color="#ff6699"
          >
            <img
              src="/logo.svg"
              alt="hungry tables"
              style={{ margin: "0 auto" }}
            />
          </DrawerHeader>

          <DrawerBody color="#7F7D95">
            <Flex height="100%">
              <VStack alignItems="baseline" w={"100%"}>
                {/* <Link to="/" style={{ width: "100%" }} onClick={handleClose}>
                  <NavItem
                    logo="/icons/dashboard.svg"
                    hoveredlogo="/icons/dashboardr.svg"
                    logoalt="dashboardlogo"
                    title="Dashboard"
                    path="/"
                  />
                </Link> */}

                {/* <Link
                  to="/usermanagement"
                  style={{ width: "100%" }}
                  onClick={handleClose}
                >
                  <NavItem
                    logo="/icons/usermanagement.svg"
                    hoveredlogo="/icons/usermanagementr.svg"
                    logoalt="usermanagementlogo"
                    title="User management"
                    path="/usermanagement"
                  />
                </Link>

                <Link
                  to="/restaurantmanagement"
                  style={{ width: "100%" }}
                  onClick={handleClose}
                >
                  <NavItem
                    logo="/icons/restaurantmanagement.svg"
                    hoveredlogo="/icons/restaurantmanagementr.svg"
                    logoalt="restaurantmanagement"
                    title="Restaurant management"
                    path="/restaurantmanagement"
                  />
                </Link> */}
                <Link to="/" style={{ width: "100%" }} onClick={handleClose}>
                  <NavItem
                    logo="/icons/casestudymanagement.svg"
                    hoveredlogo="/icons/casestudymanagementb.svg"
                    logoalt="casestudymanagement"
                    title="Casestudy management"
                    path="/"
                  />
                </Link>
                {user.userType === "ADMIN" && (
                  <Link
                    to="/servicemanagement"
                    style={{ width: "100%" }}
                    onClick={handleClose}
                  >
                    <NavItem
                      logo="/icons/servicemanagementb.svg"
                      hoveredlogo="/icons/servicemanagement.svg"
                      logoalt="servicemanagement"
                      title="Service management"
                      path="/servicemanagement"
                    />
                  </Link>
                )}
                {user.userType === "ADMIN" && (
                  <Link
                    to="/linkedcasestudymanagement"
                    style={{ width: "100%" }}
                    onClick={handleClose}
                  >
                    <NavItem
                      logo="/icons/servicemanagementb.svg"
                      hoveredlogo="/icons/servicemanagement.svg"
                      logoalt="linkedcasestudymanagement"
                      title="Linked Casestudy management"
                      path="/linkedcasestudymanagement"
                    />
                  </Link>
                )}
              </VStack>
            </Flex>
          </DrawerBody>
          <DrawerFooter display="flex" justifyContent="flex-start">
            <IconButton
              icon={
                <NavItem
                  title="Sign out"
                  logo="/icons/logout.svg"
                  hoveredlogo="/icons/logout.svg"
                  logoalt="logoutlogo"
                  hoverStyles={{ bgGradient: "none" }} // Inline override to remove bgGradient
                />
              }
              aria-label="signout"
              onClick={() => {
                localStorage.clear();
                window.location.reload();
              }}
              background="none"
              border="none"
              borderRadius="none"
              _hover={{
                background: "none",
                bgGradient: "none",
              }}
              _active={{ background: "none" }}
            />
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
